import { type CommunityAccess, type CommunityChannelProductType, communityAccess } from "../models/community"

export function getCommunityAccessDisplayName(access: CommunityAccess): string {
	switch (access) {
		case "view":
			return "Read only"
		case "react":
			return "Read and react"
		case "comment":
			return "Read, react, and comment"
		case "post":
			return "Full access"
	}
}

type GetChannelAccessArgs = {
	channel: {
		id: number | null
		defaultAccess: CommunityAccess | null
		membershipAccess: { membershipId: number; access: CommunityAccess }[]
		productAccess: { type: CommunityChannelProductType; id: number; access: CommunityAccess }[]
	}
	user: {
		isCreator?: boolean
		membership: { id: number } | null
		// The channel products the user has, as resolved by the API.
		products?: { type: CommunityChannelProductType; id: number }[]
	}
}

export function getChannelAccess(args: GetChannelAccessArgs): CommunityAccess | null {
	if (args.user.isCreator) return "post"

	const membershipAccess = args.user.membership
		? args.channel.membershipAccess.find(x => x.membershipId === args.user.membership!.id)?.access
		: undefined
	const productAccess = args.channel.productAccess
		.filter(x => args.user.products?.some(product => product.type === x.type && product.id === x.id))
		.map(x => x.access)
	return (
		[args.channel.defaultAccess, membershipAccess, ...productAccess]
			.filter(x => x !== null && x !== undefined)
			.toSorted((a, b) => communityAccess.indexOf(a) - communityAccess.indexOf(b))
			.at(-1) ?? null
	)
}

export function isCommunityAccessHigher(access: CommunityAccess, compare: CommunityAccess | null): boolean {
	return communityAccess.indexOf(access) > (compare ? communityAccess.indexOf(compare) : -1)
}
